import { render, staticRenderFns } from "./Astrologer.vue?vue&type=template&id=408635aa&scoped=true"
import script from "./Astrologer.vue?vue&type=script&lang=js"
export * from "./Astrologer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408635aa",
  null
  
)

export default component.exports